<template>
    <div class="card-data" :class="md ? 'md' : ''">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div style="justify-self: start" class="card-title">
            <h4>{{title}}</h4>
            <small v-if="sub">{{sub}}</small>
            <div style="height: 29px" v-else></div>
        </div>
        <div class="right" id="total" v-if="loader">
            <ICountUp
                :endVal="total"
                :options="options"
                class="actual"
                />
            <p class="detail">Dispositivos</p>
        </div>
        <div v-else>
            <Loader/>
        </div>
        <div class="right" v-if="loader">
            <div style="display: block; text-align: right" v-for="(item, key) in detailed" :key="key">
                <ICountUp
                :endVal="item.amount"
                :options="options"
                class="detailed"
                />
                <p class="detail">{{item.name}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'

export default {
    name: 'VisitorsCard',
    components: {
        ICountUp,
        Loader,
        Tooltip
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: false
        },
        total: {
            type: Number,
            required: false
        },
        detailed: {
            type: Array,
            required: false
        },
        tip: {
            type: String,
            required: false
        },
        md: {
            type: Boolean,
            required: false
        },
        loader: {
            type: Boolean,
            required: true
        }
    },
    data: function(){
        return {
            options: {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            }
        }
    }
}
</script>

<style lang="sass">
.card-data .actual 
    font-family: $title-font
    font-size: 40px
    font-weight: 600
    text-align: right
    color: $dark
    @media (max-width: $phone)
        font-size: 28px

.card-data .detailed 
    font-family: $title-font
    font-size: 32px
    font-weight: 600
    text-align: right
    color: $dark


.card-data .detail 
    font-family: $body-font
    font-size: 12px
    font-weight: 300
    text-align: right 
    color: $dark

</style>